<template>
  <div class="orderPage">
    <div class="select_wrap flex-between">
      <div class="dropdown_wrap">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="params.service_order_status"
            :options="serviceOrderState"
            @change="changeDropdownStatus"
          />
          <van-dropdown-item title="areaTit" ref="item">
            <div slot="title" class="custom-title">
              {{ areaTit }} <span v-if="sitetype">-{{ sitetype }}</span>
            </div>
            <div class="dropdown_wrap_container flex-rowl">
              <div class="dropdown_list">
                <div
                  class="dropdown_item flex-rowl"
                  :class="{ active: params.parameterid == item.id }"
                  v-for="(item, index) in orderParameter"
                  :key="index"
                  @click="handleArea(1, item)"
                >
                  {{ item.area_name }}
                </div>
                <div
                  class="dropdown_item place flex-rowl"
                  v-for="item in leftItem"
                  :key="'title' + item"
                ></div>
                <!-- <template v-if="letftItme > 0">
                
              </template> -->
              </div>
              <div class="dropdown_list" v-if="building.length > 0">
                <div
                  class="dropdown_item flex-rowl"
                  :class="{ active: params.buildingid == item.id }"
                  v-for="(item, index) in building"
                  :key="index"
                  @click="handleArea(2, item)"
                >
                  {{ item.building_name }}
                  <span v-if="item.sitetype" class="sitetype"
                    >-{{ item.sitetype }}</span
                  >
                </div>
                <div
                  class="dropdown_item place flex-rowl"
                  v-for="item in rightItem"
                  :key="'title' + item"
                ></div>
              </div>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>

      <div class="search_btn flex-rowc" @click="isShowPopup = true">
        查找订单 <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div>
    <div class="flex-between">
      <div class="radio_wrap flex-rowc">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#ee0a24"
          @change="changeCheck"
        ></van-checkbox>
        <span>按筛选条件只看今天的订单</span>
      </div>
      <div class="clear_condition" @click="handleClearParams">清空筛选条件</div>
    </div>
    <div class="order_num">查找到{{ total }}笔订单</div>

    <div class="order_wrap" @scroll="orderScroll($event)">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="list" v-if="dataList.length > 0">
          <div
            class="item"
            v-for="item in dataList"
            :key="item.id"
            @click="
              handleDetail(
                item.order_id,
                item.address_detail,
                item.service_order_status
              )
            "
          >
            <div class="block_one">
              <div class="column flex-rowl">
                <p class="label">创建时间：</p>
                <p class="con">{{ getTiemSplit(item.create_time) }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">订单状态：</p>
                <p class="con">
                  {{ item.service_order_statusstr }}
                </p>
              </div>
              <div class="column flex-rowl">
                <p class="label">订单情况：</p>
                <p class="con">
                  {{
                    item.service_order_property == 1
                      ? "服务订单进行中"
                      : item.service_order_property == 2
                      ? "服务订单取消申请中"
                      : item.service_order_property == 3
                      ? "服务订单已取消"
                      : "服务订单已完成"
                  }}
                </p>
              </div>
            </div>
            <div class="block_two">
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">订单号：</p>
                  <p class="con">
                    {{ item.order_id }}
                  </p>
                </div>
                <div
                  class="btn_copy code flex-rowr"
                  @click.stop="customCopy(item.order_id)"
                >
                  <i class="iconfont icon-fuzhi"></i>
                </div>
              </div>
              <div class="column flex-between">
                <div class="left flex-rowl">
                  <p class="label">餐厅名称：</p>
                  <p class="con">
                    {{ item.shop_name }}
                  </p>
                </div>
              </div>
              <div class="column flex-rowl">
                <p class="label">送餐楼栋：</p>
                <p class="con">{{ item.buildingidstr }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">用户姓名：</p>
                <p class="con">{{ item.truename }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">联系电话：</p>
                <p class="con">{{ item.customer_phone }}</p>
              </div>
              <div class="column order_content flex-rowl">
                <p class="label">订单内容：</p>
                <p class="con">{{ item.order_content }}</p>
              </div>
              <!-- 待接单、已接单状态 -->
              <div class="order_state_operation flex-rowr">
                <div class="btn flex-rowc">
                  {{
                    item.service_order_status == 3
                      ? "已全部取餐"
                      : item.service_order_statusstr
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          description="暂无订单"
          v-if="!isLoading && dataList.length == 0"
        />
      </van-pull-refresh>
    </div>
    <div
      class="fixd_custom flex-rowc"
      v-if="
        dataList.length > 0 &&
       
        params.service_order_status == 3
      "
      @click="serinfoaddGroup"
    >
     <!-- sitetype == '自提点' &&  -->
      <span class="iconfont icon-dingdanzhongxin"></span>
      <div class="txt flex-colc">
        <p>全部完成</p>
        <span>（符合本次条件的订单）</span>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <van-overlay :show="isShow" :lock-scroll="false" z-index="100001">
      <div class="custom_popup">
        <div class="custom_close flex-rowc" @click="handleClosePopup">
          <span class="iconfont icon-jujueweituo"></span>
        </div>
        <div class="custom_popup_wrap">
          <div class="list">
            <div class="item">
              <div class="block_one">
                <div class="column flex-rowl">
                  <p class="label">创建时间：</p>
                  <p class="con">{{ dataItem.order_time }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单状态：</p>
                  <p class="con">
                    {{
                      dataItem.service_order_status == 1
                        ? "待接单"
                        : dataItem.service_order_status == 2
                        ? "已接单"
                        : dataItem.service_order_status == 3
                        ? "取餐中"
                        : dataItem.service_order_status == 4
                        ? "送餐中"
                        : dataItem.service_order_status == 5
                        ? "待自提"
                        : dataItem.service_order_status == 6
                        ? "已送达"
                        : "已完成"
                    }}
                  </p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单情况：</p>
                  <p class="con">
                    {{
                      dataItem.service_order_property == 1
                        ? "服务订单进行中"
                        : dataItem.service_order_property == 2
                        ? "服务订单取消申请中"
                        : dataItem.service_order_property == 3
                        ? "服务订单已取消"
                        : "服务订单已完成"
                    }}
                  </p>
                </div>
              </div>

              <div class="block_two">
                <div class="column flex-rowl">
                  <p class="label">服务订单号：</p>
                  <p class="con">{{ dataItem.service_order_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单号：</p>
                  <p class="con">{{ dataItem.order_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">餐厅名称：</p>
                  <p class="con">{{ dataItem.shop_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐位置：</p>
                  <p class="con">{{ dataItem.address_detail }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐楼栋：</p>
                  <p class="con">{{ dataItem.buildingidstr }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">关联取餐柜：</p>
                  <p class="con">{{ dataItem.service_rating }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">用户姓名：</p>
                  <p class="con">{{ dataItem.truename }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系电话：</p>
                  <p class="con">{{ dataItem.customer_phone }}</p>
                </div>
                <div class="column">
                  <p class="label">订单内容：</p>
                  <div class="column-list">
                    <div
                      class="column-item flex-between"
                      v-for="(item, index) in orderContent"
                      :key="index"
                    >
                      <p class="txt">{{ item.ordercont }}</p>
                      <p
                        class="state flex-rowc"
                        :class="{ disabled: item.getstate == 1 }"
                        @click="singleTakeMeal(item, index)"
                      >
                        {{ item.getstate == 1 ? "已取餐" : "确认取餐" }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="column column_custom flex-rowr">
                  <div
                    class="custom_btn"
                    :class="{ disabled: dataItem.service_order_status > 2 }"
                    @click="handleAllTakeMeal"
                  >
                    {{
                      dataItem.service_order_status == 2
                        ? "全部确认取餐"
                        : "全部已取餐"
                    }}
                  </div>
                </div>
              </div>

              <div
                class="block_three"
                v-if="dataItem.service_order_status >= 3"
              >
                <div class="column flex-rowl">
                  <p class="label">取餐员：</p>
                  <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">取餐员工号：</p>
                  <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系方式：</p>
                  <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">取餐时间：</p>
                  <p class="con">{{ pickupInfo.pickup_time }}</p>
                </div>
                <div
                  class="column column_custom flex-colc"
                  v-if="dataItem.sitetype == '自提点'"
                >
                  <template v-if="dataItem.service_order_status == 3">
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          3
                        )
                      "
                    >
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                    <div
                      class="custom_btn"
                      :class="{ disabled: dataItem.service_order_status > 4 }"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          5
                        )
                      "
                    >
                      {{
                        dataItem.service_order_status > 4 &&
                        serinfoInfo.dispatch_result == 5
                          ? "已放至自提点"
                          : "放至自提点"
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="custom_btn disabled">已放至自提点</div>
                    <div class="custom_btn">
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                  </template>
                </div>
                <div class="column column_custom flex-colc" v-else>
                  <template v-if="dataItem.service_order_status == 3">
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          1
                        )
                      "
                    >
                      放入取餐柜（大件）
                    </div>
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          2
                        )
                      "
                    >
                      放入取餐柜（小件）
                    </div>
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          3
                        )
                      "
                    >
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          4
                        )
                      "
                    >
                      直接配送
                    </div>
                  </template>
                  <template v-else>
                    <div class="custom_btn disabled">
                      {{
                        serinfoInfo.dispatch_result == 1
                          ? "已放入取餐柜（大件）"
                          : serinfoInfo.dispatch_result == 2
                          ? "已放入取餐柜（小件）"
                          : "已直接送达"
                      }}
                    </div>
                    <div class="custom_btn">
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                  </template>
                </div>
              </div>

              <!-- v-if="dataItem.service_order_status >= 4" -->
              <div class="block_three" v-if="false">
                <div class="column flex-rowl">
                  <p class="label">送餐员：</p>
                  <p class="con">{{ deliveryInfo.delivery_staff_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐员工号：</p>
                  <p class="con">{{ deliveryInfo.delivery_staff_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系方式：</p>
                  <p class="con">{{ deliveryInfo.delivery_staff_contact }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐时间：</p>
                  <p class="con">{{ deliveryInfo.delivery_assignment_time }}</p>
                </div>
                <!-- 点位类型sitetype=取餐柜、自提点 -->
                <!-- <template
                  v-if="
                    serinfoInfo.dispatch_result == 1 ||
                    serinfoInfo.dispatch_result == 2
                  "
                >
                  <div class="block flex-colc" v-if="serinfoInfo.locker_number">
                    <div class="primary-button" @click="handleToast">
                      商品放错，重新操作
                    </div>
                    <div class="primary-button" @click="handleToast">
                      直接送达
                    </div>
                    <div class="primary-button" @click="handleToast">
                      订单取消
                    </div>
                  </div>
                </template> -->
                <div
                  class="column column_custom flex-colc"
                  v-if="dataItem.sitetype == '自提点'"
                >
                  <template v-if="dataItem.service_order_status == 4">
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          3
                        )
                      "
                    >
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                    <div
                      class="custom_btn"
                      :class="{ disabled: dataItem.service_order_status > 4 }"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          5
                        )
                      "
                    >
                      {{
                        dataItem.service_order_status > 4 &&
                        serinfoInfo.dispatch_result == 5
                          ? "已放至自提点"
                          : "放至自提点"
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="custom_btn disabled">已放至自提点</div>
                    <div class="custom_btn">
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                  </template>
                </div>
                <div class="column column_custom flex-colc" v-else>
                  <template v-if="dataItem.service_order_status == 4">
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          1
                        )
                      "
                    >
                      放入取餐柜（大件）
                    </div>
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          2
                        )
                      "
                    >
                      放入取餐柜（小件）
                    </div>
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          3
                        )
                      "
                    >
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                    <div
                      class="custom_btn"
                      @click="
                        handleOrderState(
                          '待配送',
                          dataItem.service_order_status,
                          4
                        )
                      "
                    >
                      直接配送
                    </div>
                  </template>
                  <template v-else>
                    <div class="custom_btn disabled">
                      {{
                        serinfoInfo.dispatch_result == 1
                          ? "已放入取餐柜（大件）"
                          : serinfoInfo.dispatch_result == 2
                          ? "已放入取餐柜（小件）"
                          : "已直接送达"
                      }}
                    </div>
                    <div class="custom_btn">
                      <a :href="'tel:' + dataItem.customer_phone">联系用户</a>
                    </div>
                  </template>
                </div>
              </div>

              <div
                class="block_three"
                v-if="dataItem.service_order_status >= 5"
              >
                <div class="column flex-rowl">
                  <p class="label">分派员：</p>
                  <p class="con">{{ serinfoInfo.dispatch_staff_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">分派员工号：</p>
                  <p class="con">{{ serinfoInfo.dispatch_staff_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系方式：</p>
                  <p class="con">{{ serinfoInfo.dispatch_staff_contact }}</p>
                </div>
                <div class="column dispath_type flex-rowl">
                  <p class="label">分派方式：</p>
                  <div class="con" v-if="serinfoInfo.dispatch_result">
                    <div class="block" v-if="serinfoInfo.dispatch_result == 4">
                      <p>直接送达用户</p>
                    </div>
                    <div class="block" v-if="serinfoInfo.dispatch_result == 5">
                      <p>已放至自提点</p>
                    </div>
                    <div
                      class="block"
                      v-else-if="serinfoInfo.dispatch_result == 1"
                    >
                      <p>放入[{{ serinfoInfo.locker_number }}]号取餐柜</p>
                      <p>
                        [{{
                          serinfoInfo.locker_compartment_number
                        }}]号柜格（大件用）
                      </p>
                      <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
                    </div>
                    <div
                      class="block"
                      v-else-if="serinfoInfo.dispatch_result == 2"
                    >
                      <p>放入[{{ serinfoInfo.locker_number }}]号取餐柜</p>
                      <p>
                        [{{
                          serinfoInfo.locker_compartment_number
                        }}]号柜格（小件用）
                      </p>
                      <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="custom_btn reset_btn"
                v-if="isShowResetBtn"
                @click="resetOrder"
              >
                业务重置
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 选择类型弹窗 start -->
    <van-popup class="custom_my_popup" v-model="isShowPopup">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="btn_item flex-between" @click="handleScance">
            <p>扫码获取</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div class="btn_item flex-between" @click="handleShowTextArea(1)">
            <p>手动输入订单号</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div class="btn_item flex-between" @click="handleShowTextArea(2)">
            <p>点餐用户手机号查询</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div class="btn_item flex-between" @click="handleShowTextArea(3)">
            <p>点餐用户姓名查询</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopup = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 选择类型弹窗 end -->

    <!-- 输入框弹窗 start -->
    <van-popup class="custom_my_popup" v-model="isShowPopupTextarea">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="textarea_box" v-if="popupType == 1">
            <van-field
              type="textarea"
              v-model="params.order_id"
              placeholder="输入订单号"
            />
          </div>
          <div class="textarea_box" v-else-if="popupType == 2">
            <van-field
              type="textarea"
              v-model="params.customer_phone"
              placeholder="输入手机号"
            />
          </div>
          <div class="textarea_box" v-else>
            <van-field
              type="textarea"
              v-model="params.truename"
              placeholder="输入用户姓名"
            />
          </div>
          <div class="custom_btn" @click="handleQuery">
            开始查找 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopupTextarea = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 输入框弹窗 end -->

    <!-- <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <template v-if="orderType == 1">
        <van-picker
          title="选择服务订单状态"
          show-toolbar
          @cancel="show = false"
          :columns="serviceOrderState"
          @confirm="onConfirmState"
        />
      </template>
      <template v-if="orderType == 2">
        <van-picker
          title="选择服务订单属性"
          show-toolbar
          @cancel="show = false"
          :columns="serviceOrderProperty"
          @confirm="onConfirmProperty"
        />
      </template>
    </van-popup> -->
  </div>
</template>

<script>
import {
  getOrderList,
  orderSendManage,
  getToken,
  getOrderParameter,
  getOrderInfo,
  getTakeMeal,
  getSendMeal,
  getDispatch,
  putBigCabinet,
  putSmallCabinet,
  serinfoaddGroup,
  isShoeReset,
  resetOrder,
  checkbonxcn,
  getOrderDetail,
  getOrderTakeMeal,
} from "../api/api";
export default {
  name: "orderMineList",
  data() {
    return {
      isShowPopupTextarea: false,
      isShowPopup: false,
      popupType: 1,

      // role 职能身份  "1","综合服务人员"|"2","取餐员"|"3","送餐员"|"4","点位服务人员"|"5","派单管理员"
      show: false,
      // 服务订单状态
      serviceOrderState: [
        {
          text: "所有状态订单",
          value: "",
        },
        {
          text: "待接单",
          value: 1,
        },
        {
          text: "已接单",
          value: 2,
        },
        {
          text: "已取餐",
          value: 3,
        },
        {
          text: "送餐中",
          value: 4,
        },
        {
          text: "待自提（已放入餐柜）",
          value: 5,
        },
        {
          text: "已送达（直达/或送至自提点）",
          value: 6,
        },
        {
          text: "已完成",
          value: 7,
        },
      ],
      // 服务订单属性
      serviceOrderProperty: [
        {
          text: "所有情况订单",
          value: "",
        },
        {
          text: "服务订单进行中",
          value: 1,
        },
        {
          text: "服务订单已取消（已退款）",
          value: 2,
        },
        {
          text: "服务订单已取消",
          value: 3,
        },
        {
          text: "服务订单已完成",
          value: 4,
        },
      ],

      checked: true,
      orderType: 1,
      orserState: "所有状态订单",
      orderProperty: "所有情况订单",
      params: {
        Page: 1,
        token: "",
        PageSize: 20,
        order_id: "",
        service_order_status: "",
        service_order_property: "",
        istoday: 1, // 1 是 0 否
        get_staff_id: "",
        parameterid: "",
        buildingid: "",
        sitetype: "",
        customer_phone: "",
        truename: "",
      },
      sitetype: "",

      isLoading: true,
      total: 0,
      dataList: [],

      dept: "",
      orderParameter: [], // 区域
      building: [], // 楼栋
      areaTit: "区域",
      leftItem: [],
      rightItem: [],

      isShow: false,
      dataItem: "", // 订单信息
      orderContent: "", // 订单内容
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息

      userInfo: "",

      isShowResetBtn: false, // 是否显示重置按钮
    };
  },
  created() {
    console.log(this.$route);
    if (this.$route.params.id) {
      this.params.order_id = this.$route.params.id;
    }
    let userInfo = this.$store.state.USERINFO;
    this.userInfo = userInfo;
    // this.params.get_staff_id = userInfo.openid;
    if (userInfo.dept.length > 0) {
      this.dept = userInfo.dept[0];
    }
    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    handleShowTextArea(type) {
      this.isShowPopup = false;
      this.isShowPopupTextarea = true;
      this.popupType = type;
    },
    handleQuery() {
      let { popupType } = this;
      if (popupType == 1) {
        this.params.customer_phone = "";
        this.params.truename = "";
      } else if (popupType == 2) {
        this.params.order_id = "";
        this.params.truename = "";
      } else if (popupType == 3) {
        this.params.customer_phone = "";
        this.params.order_id = "";
      }
      this.params.Page = 1;
      this.dataList = [];
      this.isShowPopupTextarea = false;
      this.getToken();
    },

    // 刷新 token 的方法
    async refreshToken() {
      try {
        const res = await getToken();
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
        } else {
          throw new Error(res.message || "获取 token 失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "获取 token 失败，请稍后重试");
        throw error;
      }
    },

    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getOrderList();
          this.getOrderParameter(res.data.token);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
    onRefresh() {
      this.params.Page = 1;
      this.getOrderList(true);
    },
    // 获取区域
    getOrderParameter(token) {
      getOrderParameter({ token }).then((res) => {
        if (res.error_code == 0) {
          this.orderParameter = res.data;
        }
      });
    },
    //
    getOrderList(isRefresh) {
      let { params } = this;
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderList(params).then((res) => {
        if (res.error_code == 0) {
          if (isRefresh) {
            this.params.Page = 1;
            this.dataList = [];
          }
          this.total = res.data.total;
          res.data.list.forEach((item) => {
            const items = item.order_content.split(",");
            item.orderContent = items.map((item) => ({
              name: item,
              isDispatched: false,
            }));
          });
          this.dataList = this.dataList.concat(...res.data.list);
          this.isLoading = false;
        } else {
          this.dataList = [];
        }
        toast.clear();
      });
    },

    // 根据需求调整，取餐-送餐合并
    async getTakeSendMeal(order_id, address_detail, token) {
      let { userInfo } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      // 1、取餐
      let takeParams = {
        order_id,
        token,
        pickup_staff_name: userInfo.truename,
        pickup_staff_id: userInfo.accountid,
        pickup_staff_contact: userInfo.mobile,
      };
      let res1 = await getTakeMeal(takeParams);
      if (res1.error_code == 0) {
        // 2、送餐
        let sendParams = {
          order_id,
          token,
          delivery_staff_name: userInfo.truename,
          delivery_staff_id: userInfo.accountid,
          delivery_staff_contact: userInfo.mobile,
          current_location: address_detail,
        };
        let res2 = await getSendMeal(sendParams);
        if (res2.error_code == 0) {
          toast.clear();
          this.getOrderInfo(order_id, token);
        } else {
          this.$toast.fail(res2.message || "接口失效，请稍后～");
          setTimeout(() => {
            this.getOrderInfo(order_id, token);
          }, 500);
        }
      } else {
        this.$toast.fail(res1.message || "接口失效，请稍后～");
        setTimeout(() => {
          this.getOrderInfo(order_id, token);
        }, 500);
      }
    },

    // 提交配送
    getDispatch(token, dispatch_result) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      let params = {
        order_id,
        token,
        dispatch_staff_id: userInfo.accountid,
        dispatch_result,
      };
      getDispatch(params).then((res) => {
        if (res.error_code == 0) {
          // toast.clear();
          // this.$toast.success(res.message);
          // if (params.dispatch_result == 1) {
          //   this.putBigCabinet(order_id, token);
          // } else if (params.dispatch_result == 2) {
          //   this.putSmallCabinet(order_id, token);
          // } else {

          // }
          setTimeout(() => {
            this.getOrderInfo(order_id, token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    checkbonxcnWithRetry(token, order_id, dispatch_result, retryCount = 0) {
      let params = {
        token,
        order_id,
      };

      // 调用 checkbonxcn 方法
      checkbonxcn(params)
        .then((res) => {
          if (res.error_code == 200) {
            // 如果返回200，直接执行下一步
            this.getDispatch(token, dispatch_result);
          } else {
            // 如果返回的不是200，并且重试次数小于等于 1 次
            if (retryCount < 4) {
              // 设置重试，每次重试的间隔时间是 2 秒
              setTimeout(() => {
                this.checkbonxcnWithRetry(
                  token,
                  order_id,
                  dispatch_result,
                  retryCount + 1
                );
              }, 2000);
            } else {
              // 如果重试次数达到最大限制（2次重试，6秒），提示失败
              this.$toast.fail(res.message || "服务器异常，请稍后");
            }
          }
        })
        .catch(() => {
          // 如果发生错误，提示失败
          this.$toast.fail("请求失败，请稍后再试");
        });
    },

    // 启动时调用的函数（首次调用）
    checkbonxcn(token, order_id, dispatch_result) {
      // 设置一个超时时间限制 10s
      let timeout = setTimeout(() => {
        // 超时后提示失败
        this.$toast.fail("请求超时，请稍后再试");
      }, 7000); // 7 秒超时

      // 调用带重试的函数
      this.checkbonxcnWithRetry(token, order_id, dispatch_result);

      // 如果成功，不需要超时提示
      clearTimeout(timeout);
    },

    // 放入大柜
    putBigCabinet(token, order_id, dispatch_result) {
      putBigCabinet({ token, order_id }).then((res) => {
        if (res.error_code != 0) {
          this.$toast.fail(res.message || "服务器异常，请稍后");
        } else {
          setTimeout(() => {
            // this.getOrderInfo(order_id, token);
            this.checkbonxcn(token, order_id, dispatch_result);
          }, 500);
        }
        // this.getBoxState(token);
      });
    },

    // 放入小柜
    putSmallCabinet(token, order_id, dispatch_result) {
      putSmallCabinet({ token, order_id }).then((res) => {
        if (res.error_code != 0) {
          this.$toast.fail(res.message || "服务器异常，请稍后");
        } else {
          setTimeout(() => {
            // this.getOrderInfo(order_id, token);
            this.checkbonxcn(token, order_id, dispatch_result);
          }, 500);
        }
        // this.getBoxState(token);
      });
    },

    // 查看订单详情
    async getOrderInfo(order_id, token) {
      try {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        const res = await getOrderInfo({ order_id, token });
        if (res.error_code != 0) {
          throw new Error(res.message || "获取订单详情失败");
        }
        if (Object.values(res.data).length != 0) {
          this.dataItem = res.data;
          this.pickupInfo = res.data.pickup;
          this.deliveryInfo = res.data.delivery;
          this.serinfoInfo =
            Object.values(res.data.serinfo).length != 0 ? res.data.serinfo : "";

          await new Promise((resolve) => setTimeout(resolve, 200));
          this.getOrderDetail(this.dataItem.order_id, token);
        } else {
          this.dataItem = "";
          this.pickupInfo = "";
          this.deliveryInfo = "";
          this.serinfoInfo = "";
          this.$toast.fail("暂无详情数据");
        }
      } catch (error) {
        this.$toast.fail(error.message || "接口失效，请稍后～");
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 获取订单商品明细
    async getOrderDetail(order_id, token) {
      try {
        const res = await getOrderDetail({
          token,
          order_id,
        });
        if (!res.result) {
          throw new Error(res.message || "获取订单商品明细失败");
        }
        this.orderContent = res.list;
        this.isShow = true;
        this.$toast.clear();
      } catch (error) {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    // 订单取餐-订单送餐-订单配送
    handleOrderState(type, orderState, dispatch_result) {
      let { dataItem } = this;
      let order_id = dataItem.order_id;
      if (type == "待取餐") {
        if (dataItem.service_order_status > 2) return;
      } else if (type == "待送餐") {
        if (dataItem.service_order_status > 3) return;
      } else if (type == "待配送") {
        if (dataItem.service_order_status > 4) return;
      }
      this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          if (type == "待取餐" && orderState == 2) {
            this.getTakeMeal(res.data.token);
          }
          // else if (type == "待送餐" && orderState == 3) {
          //   this.getSendMeal(res.data.token);
          // }
          // 因为将送餐环节取消，所以待配送的时候orderState = 3
          else if (type == "待配送" && orderState == 3) {
            if (dispatch_result == 1) {
              this.putBigCabinet(res.data.token, order_id, dispatch_result);
            } else if (dispatch_result == 2) {
              this.putSmallCabinet(res.data.token, order_id, dispatch_result);
            } else {
              this.getDispatch(res.data.token, dispatch_result);
            }
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 调用商品取餐接口
    async getOrderTakeMeal(item, index) {
      try {
        let { userInfo } = this;
        let params = {
          order_id: item.order_id,
          token: this.params.token,
          pickup_staff_id: userInfo.accountid,
          id: item.id,
        };
        let res = await getOrderTakeMeal(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.params.token;
          res = await getOrderTakeMeal(params);
        }
        if (res.error_code == 0) {
          // 修改该条商品的取餐状态
          this.$set(this.orderContent, index, { ...item, getstate: 1 });
        } else {
          throw new Error(res.message || "取餐失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    /**
     * 单个商品取餐
     * @param {Object} item - 商品对象
     * @param {number} index - 商品在数组中的索引
     */
    async singleTakeMeal(item, index) {
      try {
        // 判断是否取餐
        if (item.getstate == 1) return;
        this.$toast.loading({
          message: "取餐中...",
          forbidClick: true,
          duration: 0,
        });
        await this.getOrderTakeMeal(item, index);
        await new Promise((resolve) => setTimeout(resolve, 200));
        // 清除加载提示
        this.$toast.clear();
        // 检查是否所有商品都已取餐
        const allTaken = this.orderContent.every((item) => item.getstate == 1);
        if (allTaken) {
          await this.getOrderInfo(this.dataItem.order_id, this.params.token);
        }
      } catch (error) {
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    /**
     * 全部商品取餐
     */
    async handleAllTakeMeal() {
      const pendingItems = this.orderContent.filter(
        (item) => item.getstate == 0
      );
      if (pendingItems.length == 0) {
        return;
      }
      this.$toast.loading({
        message: "全部取餐中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        for (let i = 0; i < pendingItems.length; i++) {
          const item = pendingItems[i];
          const index = this.orderContent.indexOf(item);
          await this.getOrderTakeMeal(item, index);
        }
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.$toast.clear();
        this.getOrderInfo(this.dataItem.order_id, this.params.token);
      } catch (error) {
        this.$toast.fail("部分商品取餐失败，请重试");
      }
    },

    // 提交取餐--遗弃该功能
    getTakeMeal(token) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      let params = {
        order_id,
        token,
        pickup_staff_name: userInfo.truename,
        pickup_staff_id: userInfo.accountid,
        pickup_staff_contact: userInfo.mobile,
      };
      getTakeMeal(params).then((res) => {
        if (res.error_code == 0) {
          // this.$toast.success(res.message);
          setTimeout(() => {
            // this.$toast.clear();
            this.getOrderInfo(order_id, token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交送餐
    getSendMeal(token) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      let params = {
        order_id,
        token,
        delivery_staff_name: userInfo.truename,
        delivery_staff_id: userInfo.accountid,
        delivery_staff_contact: userInfo.mobile,
        current_location: dataItem.address_detail,
      };
      getSendMeal(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          toast.clear();
          setTimeout(() => {
            this.getOrderInfo(order_id, token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    async serinfoaddGroup() {
      try {
        this.$toast.loading({
          message: "请稍后...",
          forbidClick: true,
          duration: 0,
        });
        let params = {
          token: this.params.token,
          get_staff_id: this.userInfo.openid,
          dispatch_result: 4,
          parameterid: this.params.parameterid,
          buildingid: this.params.buildingid,
        };
        let res = await serinfoaddGroup(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await serinfoaddGroup(params);
        }
        if (res.error_code == 0) {
          await new Promise((resolve) => setTimeout(resolve, 400));
          this.getOrderList(true);
        } else {
          throw new Error(res.message || "取餐失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    // 关闭弹窗
    handleClosePopup() {
      this.isShow = false;
      this.getOrderList(true);
    },

    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getOrderList();
        }
      }
    },
    handleShow(type) {
      this.orderType = type;
      this.show = true;
    },
    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeCheck(e) {
      this.params.istoday = e ? 1 : 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownStatus(e) {
      console.log(e, "=========");
      this.params.service_order_status = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownProperty(e) {
      console.log(e, "=========");
      this.params.service_order_property = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    handleArea(type, item) {
      if (type == 1) {
        this.params.parameterid = item.id;
        this.building = item.buildings;
        if (this.orderParameter.length < this.building.length) {
          let num = this.building.length - this.orderParameter.length;
          this.leftItem = Array.from({ length: num }, (_, index) => index + 1);
        } else {
          this.leftItem = 0;
          let num = this.orderParameter.length - this.building.length;
          this.rightItem = Array.from({ length: num }, (_, index) => index + 1);
        }
      } else {
        this.params.buildingid = item.id;
        this.sitetype = item.sitetype;
        this.$refs.item.toggle();
        this.params.Page = 1;
        this.dataList = [];
        this.areaTit = item.building_name;
        this.getOrderList();
      }
    },
    // onConfirmState(e) {
    //   let { text, value } = e;
    //   this.orserState = text;
    //   this.params.service_order_status = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    // onConfirmProperty(e) {
    //   let { text, value } = e;
    //   this.orderProperty = text;
    //   this.params.service_order_property = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    handleClearParams() {
      this.params.order_id = "";
      this.params.customer_phone = "";
      this.params.service_order_status = "";
      this.params.service_order_property = "";
      this.params.parameterid = "";
      this.params.buildingid = "";
      this.sitetype = "";
      (this.orserState = "所有状态订单"),
        (this.orderProperty = "所有情况订单"),
        // (this.params.istoday = 0);
        (this.params.Page = 1);
      this.dataList = [];
      (this.areaTit = "区域"), this.getOrderList();
    },
    /**
     * 自定义复制功能
     * @param {string} text - 需要复制的文本
     */
    async customCopy(text) {
      try {
        // 检查浏览器是否支持 Clipboard API
        if (navigator.clipboard) {
          // 调用 Clipboard API 进行复制
          await navigator.clipboard.writeText(text);
          this.$toast({
            message: "复制成功",
          });
        } else {
          // 不支持 Clipboard API 时的降级处理
          const textarea = document.createElement("textarea");
          textarea.value = text;
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          this.$toast({
            message: "复制成功",
          });
        }
      } catch (error) {
        this.$toast({
          message: "复制失败，请稍后重试",
        });
        console.error("复制失败:", error);
      }
    },

    handleDetail(id, address_detail, order_status) {
      // this.$router.push(
      //   `/orderIndex/orderMineDetail/${id}/${address_detail}/${order_status}`
      // );
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.getOrderInfo(id, res.data.token);
          console.log(address_detail, order_status);
          this.isShoeReset(id, res.data.token);
          // if (order_status <= 4) {
          //   this.getTakeSendMeal(id, address_detail, res.data.token);
          // } else {
          //   this.getOrderInfo(id, res.data.token);
          // }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 判断订单是否异常
    isShoeReset(id, token) {
      isShoeReset({ token, order_id: id }).then((res) => {
        if (res.error_code == 101) {
          this.isShowResetBtn = true;
        } else {
          this.isShowResetBtn = false;
        }
      });
    },

    // 重置操作
    resetOrder() {
      let { order_id } = this.dataItem;
      const toast = this.$toast.loading({
        message: "重置中...",
        forbidClick: true,
        duration: 0,
      });
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          resetOrder({ token: res.data.token, order_id }).then((res1) => {
            if (res1.error_code == 0) {
              toast.clear();
              this.$toast.success(res1.message);
              setTimeout(() => {
                this.isShoeReset(order_id, res.data.token);
                this.getOrderInfo(order_id, res.data.token);
              }, 500);
            } else {
              this.$toast.fail(res1.message || "接口失效，请稍后～");
            }
          });
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 触发接单事件
    handleOrder(state, order_id) {
      // state=2 已接单
      let that = this;
      if (state == 2) return;
      this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        loadingType: "spinner",
      });
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          orderSendManage({ token: res.data.token, order_id }).then((res1) => {
            if (res1.error_code == 0) {
              this.$toast.success("接单成功");
              this.params.token = res.data.token;
              setTimeout(() => {
                this.params.Page = 1;
                that.getOrderList(true);
              }, 800);
            } else {
              this.$toast.fail(res.message || "接口失效，请稍后～");
            }
          });
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
      console.log(order_id, "-----未接单");
    },

    handleToast() {
      this.$toast("即将开放");
    },

    // 扫码
    handleScance() {
      this.$router.push(`/qrcode/5`);
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .search_wrap {
    width: 660px;
    height: 80px;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 45px;
    margin: auto;
    background: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 25px;
    /deep/ .van-cell {
      padding: 0;
      background: none;
      flex-shrink: 0;
      border: none;
      flex: 1;
    }
    /deep/ .van-field__control {
      text-align: center;
    }
    .search_btn {
      flex-shrink: 0;
      width: 70px;
      .iconfont {
        font-size: 40px;
        color: #d6d0d1;
      }
    }
  }
  .select_wrap {
    width: 660px;
    margin: auto;
    box-sizing: border-box;
    .dropdown_wrap {
      width: 500px;
      flex-shrink: 0;
    }
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
    .search_btn {
      flex-shrink: 0;
      width: 160px;
      font-size: 24px;
      background: #096f70;
      color: #fff;
      margin-left: 10px;
      white-space: nowrap;
      height: 90px;
      .iconfont {
        font-size: 28px;
        margin-left: 5px;
      }
    }
  }
  .radio_wrap {
    font-size: 24px;
    color: #1e1e1e;
    margin: 25px auto;
    span {
      margin-left: 16px;
    }
  }
  .clear_condition {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border: 3px solid #096f70;
    border-radius: 35px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
    text-align: center;
    line-height: 60px;
  }
  .order_num {
    width: 660px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
  }
  .order_wrap {
    margin-top: 25px;
    height: 73vh;
    overflow-y: scroll;
    padding-bottom: 200px;
    box-sizing: border-box;
    .list {
      .item {
        width: 660px;
        // min-height: 700px;
        background: #ffffff;
        border: 6px solid #e6e6e6;
        border-radius: 40px;
        margin: 0 auto 30px;
        padding: 52px 44px;
        box-sizing: border-box;
        font-size: 28px;
        color: #040000;
        .block_one {
          font-size: 30px;
          margin-bottom: 45px;
          .column {
            &:nth-child(2n) {
              margin: 10px 0;
            }
            .label {
              width: 140px;
            }
            .con {
              color: #ff0000;
            }
          }
        }
        .block_two {
          // margin-bottom: 99px;
          font-size: 28px;
          position: relative;
          .column {
            &:last-child {
              margin-bottom: 0;
            }
          }
          .order_state_operation {
            margin-top: 30px;
            .btn {
              // width: 130px;
              padding: 0 30px;
              height: 40px;
              background: #096f70;
              border-radius: 45px;
              text-align: center;
              font-size: 20px;
              color: #fff;
              &.disabled {
                background: #9e9e9e;
              }
            }
          }
        }
        .column {
          align-items: flex-start;
          &:nth-child(2n) {
            margin: 26px 0;
          }
          .left {
            align-items: flex-start;
            .con {
              width: 320px;

              flex-shrink: 0;
            }
          }
          .label {
            white-space: nowrap;
            width: 140px;
            flex-shrink: 0;
          }
          .con {
            word-wrap: break-word;
            flex: 1;
            span {
              margin-left: 10px;
            }
          }
          .iconfont {
            font-size: 30px;
          }
          &.order_content {
            .con {
              flex-shrink: 0;
              width: 270px;
            }
          }
        }
      }
    }
  }
  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
  .custom-title {
    span {
      font-size: 20px;
    }
  }
  .dropdown_wrap_container {
    padding: 0 30px;
    box-sizing: border-box;
    align-items: flex-start;
    .dropdown_list {
      flex: 1;
      font-size: 26px;
      color: #323233;
      .dropdown_item {
        height: 70px;
        border-bottom: 1px solid #ebedf0;
        &.active {
          color: #ee0a24;
        }
        .sitetype {
          font-size: 22px;
        }
        // &.place {
        //   opacity: 0;
        // }
      }
    }
  }
  .column-list {
    margin: 30px 0 30px;
    .column-item {
      font-size: 24px;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      .txt {
        line-height: 28px;
      }
      .state {
        flex-shrink: 0;
        margin-left: 40px;
        width: 130px;
        height: 40px;
        border-radius: 50px;
        background: #096f70;
        color: #fff;
        font-size: 22px;
        &.disabled {
          background: #9e9e9e;
        }
      }
    }
  }
  .btn_copy {
    width: 70px;
    flex-shrink: 0;
  }
  .custom_popup {
    width: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    .custom_close {
      position: fixed;
      right: 0;
      top: -70px;
      .iconfont {
        font-size: 52px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .custom_popup_wrap {
      background: #ffffff;
      overflow-y: scroll;
      height: 84vh;
      .list {
        padding: 20px 10px;
        box-sizing: border-box;
        .item {
          // width: 660px;
          // min-height: 700px;

          // border: 6px solid #e6e6e6;
          // border-radius: 40px;
          margin: 0 auto 240px;
          padding: 52px 44px 0;
          box-sizing: border-box;
          font-size: 28px;
          color: #040000;
          .column {
            &.column_custom {
              margin-top: 35px;
              .custom_btn {
                margin: 0;
                &.disabled {
                  background: #9e9e9e;
                  color: #fff;
                }
                a {
                  color: #fff;
                }
              }
              &.flex-colc {
                align-items: flex-end;
                .custom_btn {
                  margin-bottom: 25px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                }
              }
            }
          }
          .block_one {
            font-size: 30px;
            margin-bottom: 65px;
            .column {
              .label {
                width: 140px;
              }
              .con {
                color: #ff0000;
              }
            }
          }
          .block_two {
            margin-bottom: 99px;
          }
          .block_three {
            margin-bottom: 85px;
          }
          .btn {
            margin-bottom: 60px;
          }
          .column {
            align-items: flex-start;
            &:nth-child(2n) {
              margin: 26px 0;
            }
            .label {
              white-space: nowrap;
              width: 190px;
              flex-shrink: 0;
            }
            .con {
              word-wrap: break-word;
              flex-shrink: 0;
              width: 380px;
            }
          }
          .block {
            align-items: flex-end;
            .primary-button {
              height: 60px;
              line-height: 60px;
              margin-bottom: 25px;
              width: 280px;
              box-sizing: border-box;
              font-size: 16px;
              &:first-child {
                margin-top: 40px;
              }
            }
            p {
              line-height: 40px;
            }
          }
          .reset_btn {
            margin-top: 180px;
          }
        }
      }
    }
  }
  .fixd_custom {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 210px;
    width: 360px;
    height: 70px;
    background: #096f70;
    border-radius: 45px;
    font-size: 30px;
    color: #fff;
    z-index: 1001;
    .iconfont {
      font-size: 36px;
    }
    .txt {
      span {
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  /deep/ .van-popup.custom_my_popup {
    background: transparent;
  }
  .popup_container {
    position: relative;
    // height: 600px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .popup_wrap {
      width: 660px;
      // height: 500px;
      box-sizing: border-box;
      padding: 30px 0;
      background: #fff;
      .btn_item {
        width: 600px;
        height: 150px;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        padding: 0 60px 0 68px;
        box-sizing: border-box;
        margin: 0 auto 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon-youjiantou {
          font-size: 30px;
          color: #515151;
        }
      }
      .textarea_box {
        border-radius: 0;
        margin-bottom: 40px;
        padding: 15px 20px;
        box-sizing: border-box;
        /deep/ .van-cell {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        /deep/ .van-field__body {
          height: 100%;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
      .custom_btn {
        background: #373737;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 20px;
        }
      }
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      .iconfont {
        font-size: 50px;
        color: #fff;
      }
    }
  }
}
</style>